<template>
  <div>
    <LoadingPage v-if="isLoadPage" />
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <ValidationObserver ref="observer">
            <b-form @submit="onSubmit">
              <card no-body  header-classes="bg-transparent">
                <b-card-header>
                  <h2 slot="header" class="mb-0">รายละเอียดลูกค้า</h2>
                </b-card-header>
                <b-card-body>
                  <b-row class="mb-4">
                    <b-col lg="12" class="my-2">
                      <h4 class="text-muted">ข้อมูลลูกค้า</h4>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="6" cols="12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group label="ชื่อร้านค้า/บริษัท">
                          <b-form-input
                            v-model="customerDetails.shop_name"
                            :state="!errors.length ? null : false"
                          />
                          <b-form-invalid-feedback>{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <b-col lg="6" cols="12">
                      <b-form-group label="รหัสร้านค้า">
                        <label v-if="customerDetails.id">{{
                          `MG-${customerDetails.id.toString().padStart(6, "0")}`
                        }}</label>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <hr class="my-3" />
                  <b-row>
                    <b-col lg="6" cols="12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group label="ชื่อ">
                          <b-form-input
                            v-model="customerDetails.firstname"
                            :state="!errors.length ? null : false"
                          />
                          <b-form-invalid-feedback>{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <b-col lg="6" cols="12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group label="นามสกุล">
                          <b-form-input
                            v-model="customerDetails.lastname"
                            :state="!errors.length ? null : false"
                          />
                          <b-form-invalid-feedback>{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="6" cols="12">
                      <ValidationProvider rules="required|email" v-slot="{ errors }">
                        <b-form-group label="อีเมล์">
                          <b-form-input
                            v-model="customerDetails.email"
                            :state="!errors.length ? null : false"
                          />
                          <b-form-invalid-feedback>{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <b-col lg="6" cols="12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group label="เบอร์โทรศัพท์">
                          <b-form-input
                            v-model="customerDetails.phonenumber"
                            :state="!errors.length ? null : false"
                          />
                          <b-form-invalid-feedback>{{
                              errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <hr class="my-3" />
                  <b-row>
                    <b-col lg="12" class="my-2">
                      <h4 class="text-muted">เส้นทางตั้งต้น</h4>
                      <small class="text-warning">
                        <i class="fas fa-exclamation-circle"></i>
                        หากคุณสร้างเส้นทางตั้งต้น รายการนี้จะถูกดึงไปใช้ในหน้าสร้างงานได้
                      </small>
                    </b-col>
                    <b-col lg="12" class="card-border-radius px-0 my-2">
                      <JobRoute :form="customerDetails"/>
                    </b-col>
                  </b-row>
                  <hr class="my-4" />
                  <div class="d-flex justify-content-end">
                    <base-button type="secondary" class="" @click="$router.go(-1)">
                      ย้อนกลับ
                    </base-button>
                    <b-button
                      type="submit"
                      variant="primary"
                      :disabled="isLoading"
                      class="w-25"
                      >บันทึก</b-button
                    >
                  </div>
                </b-card-body>
              </card>
            </b-form>
          </ValidationObserver>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { modalSuccess, modalError } from '@/util/alert.js'
import customerServices from "@/api/customer.service.js";
import JobRoute from "@/views/Pages/Admin/Job/components/JobRoute.vue";

export default {
  components: { 
    JobRoute,
    ValidationObserver,
    ValidationProvider,
  },
  props: {},
  data() {
    return {
      isLoadPage: false,
      isLoading: false,
      customerDetails: {
        id: null,
        shop_name: null,
        firstname: null,
        lastname:null,
        email: null,
        phonenumber: null,
        categoryRoutes: []
      },
    };
  },
  created() {},
  methods: {
    async getCustomer() {
      try {
        this.isLoadPage = true;
        const res = await customerServices.getCustomerByOne(
          this.$route.params.id
        );
        const data = res.data.data;
        
        const categoryRoutesFormat = (data && data.routes) ? data.routes.map(item => {
          return {
            name: item.name,
            routes: [...item.customer_route_details]
          }
        }) : [];

        this.customerDetails = {
          id: data.id,
          firstname: data.firstname,
          lastname: data.lastname,
          email: data.email, 
          phonenumber: data.phonenumber,
          shop_name: data.shop_name,
          categoryRoutes: categoryRoutesFormat
        }
      } catch (err) {}
      finally{ this.isLoadPage = false }
    },
    async onSubmit(event) {
      event.preventDefault();
      const isValid = await this.$refs.observer.validate();

      if (!isValid) {
        return;
      }

      this.isLoading = true;

      const payload = {
        customer_id: this.customerDetails.id,
        shop_name: this.customerDetails.shop_name,
        firstname: this.customerDetails.firstname,
        lastname: this.customerDetails.lastname,
        email: this.customerDetails.email,
        phonenumber: this.customerDetails.phonenumber,
        customer_routes: this.customerDetails.categoryRoutes.map( item => {
          return {
            name: item.name,
            customer_route_details: item.routes.map( item => {
              return {
                name: item.name,
                url: item.url
              }
            })
          }
        })
      }

      try{
        const response = await customerServices.updateCustomer(payload);

        modalSuccess(this.$bvModal, 'แก้ไขข้อมูลลูกค้าสำเร็จ')
      }catch(error){
        modalError(this.$bvModal, 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
      }finally{
        this.isLoading = false
      }
    },
  },
  mounted() {
    if( this.$route.params.id ){
      this.getCustomer();
    }
  },
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
